import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Autocomplete } from '@components/Autocomplete'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { SearchPanelContainer } from '@components/Search'
import { StatusFilter } from '@components/StatusFilter'
import Scroll from '@components/Scroll'
import Button from '@components/Button'
import Checkbox from '@components/Checkbox'
import FilterGroup from '@components/FilterGroup'
import ContactSearchResults from './ClientContactSearchResults'
import Pagination from '@components/Pagination'
import Spinner from '@components/spinner'

class ContactSearchPanel extends Component {
  static propTypes = {
    clientContactSearchStore: PropTypes.object,
    modalStore: PropTypes.object,
    baseUrl: PropTypes.string,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { clientContactSearchStore } = props
    clientContactSearchStore.search()
  }

  renderLoader () {
    return <Spinner />
  }

  onRefresh = () => {
    this.props.clientContactSearchStore.clearSearch()
  }

  search = () => {
    this.props.clientContactSearchStore.query.page = 1
    this.props.clientContactSearchStore.search()
  }

  render () {
    const { clientContactSearchStore } = this.props
    const {
      selectedCountry,
      autocompleteSuggestion,
      officeAutocompleteSuggestion,
      numberOfContacts,
      query
    } = clientContactSearchStore
    const { baseUrl, history } = this.props
    return (
      <div className='expert-search-panel'>
        <div className='expert-search-panel-container'>
          <SearchPanelContainer
            thin
            buttonProps={{
              dataCy: 'create-client-btn',
              buttonText: 'Add new contact',
              onClick: () =>
                this.props.modalStore.show({
                  type: 'CLIENT_CONTACT_FORM',
                  props: {
                    onSaveSuccess: savedContact => {
                      history.push('/client-contact/' + savedContact.id)
                      this.props.modalStore.close()
                    }
                  }
                })
            }}
            searchTitle='Filter Contacts'
            onClearSearch={this.onRefresh}
          >
            <FilterGroup label='Client contact name or email'>
              <input
                value={query.keyword}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    this.search()
                  }
                }}
                onChange={e => {
                  clientContactSearchStore.query.keyword = e.target.value
                }}
              />
            </FilterGroup>
            <FilterGroup label='Client account or parent account'>
              <Autocomplete
                value={autocompleteSuggestion}
                itemToString={item => item && item.name}
                onChange={value => {
                  clientContactSearchStore.autocompleteSuggestion = value
                }}
                loadOptions={clientContactSearchStore.autocomplete}
              />
            </FilterGroup>
            <FilterGroup label='Client office'>
              <Autocomplete
                value={officeAutocompleteSuggestion}
                itemToString={item => item && item.officeName}
                onChange={value => {
                  clientContactSearchStore.officeAutocompleteSuggestion = value
                }}
                loadOptions={clientContactSearchStore.officeAutocomplete}
              />
            </FilterGroup>
            <FilterGroup label='Country'>
              <Autocomplete
                placeholder='All countries'
                itemToString={item => item && item.name}
                value={selectedCountry}
                onChange={clientContactSearchStore.searchCountry}
                options={clientContactSearchStore.countries}
              />
            </FilterGroup>
            <FilterGroup label='Status'>
              <StatusFilter
                single
                required
                selectedItems={[clientContactSearchStore.query.status]}
                items={['active', 'inactive', 'all']}
                onChange={item => {
                  clientContactSearchStore.query.status = item[0]
                }}
              />
            </FilterGroup>
            <FilterGroup>
              <Checkbox
                label='Compliance auditor'
                value={clientContactSearchStore.query.complianceAuditor}
                onChange={e => {
                  clientContactSearchStore.query.complianceAuditor = e
                }}
              />
            </FilterGroup>
            <FilterGroup>
              <Checkbox
                label='KM Only'
                value={clientContactSearchStore.query.knowledgeManager}
                onChange={e => {
                  clientContactSearchStore.query.knowledgeManager = e
                }}
              />
            </FilterGroup>
            <FilterGroup label='Atheneum contact name (for KM only)'>
              <input
                value={query.atheneumContactName}
                onChange={e => {
                  clientContactSearchStore.query.atheneumContactName =
                    e.target.value
                }}
              />
            </FilterGroup>
            <Button primary onClick={this.search}>
              Search
            </Button>
          </SearchPanelContainer>
          <div className='search-panel-results'>
            <Scroll>
              <ContactSearchResults
                baseUrl={baseUrl}
                clientContactSearchStore={clientContactSearchStore}
              />
              <Pagination
                maxPages={100}
                total={numberOfContacts}
                perPage={10}
                page={clientContactSearchStore.query.page}
                onChange={p => clientContactSearchStore.changePage(p)}
              />
            </Scroll>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(inject('modalStore')(observer(ContactSearchPanel)))
